<div class="language-selector" (document:click)="onDocumentClick($event)">
  <!-- Current Language Button -->
  <button
    class="language-button"
    type="button"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isDropdownOpen"
    [disabled]="isLoading"
    aria-haspopup="true"
        [attr.aria-label]="
            'Select language. Current: ' + (currentLanguage?.name || 'Unknown')
        "
    [class.loading]="isLoading"
    [class.error]="hasError"
    >
    <!-- Loading Spinner -->
    @if (isLoading) {
      <span class="loading-spinner" aria-hidden="true">
        <i class="bi bi-arrow-clockwise spin"></i>
      </span>
    }

    <!-- Language Flag -->
    @if (currentLanguage?.flag && !isLoading) {
      <span class="language-flag">
        {{ currentLanguage?.flag }}
      </span>
    }

    <!-- Language Code -->
    <span class="language-code">
      {{ currentLanguage?.code?.toUpperCase() || "FR" }}
    </span>

    <!-- Error Indicator -->
    @if (hasError && !isLoading) {
      <i
        class="bi bi-exclamation-triangle error-icon"
        aria-hidden="true"
      ></i>
    }

    <!-- Dropdown Arrow -->
    @if (!isLoading && !hasError) {
      <i
        class="bi bi-chevron-down dropdown-arrow"
        [class.rotated]="isDropdownOpen"
      ></i>
    }
  </button>

  <!-- Dropdown Menu -->
  <div
    class="language-dropdown"
    [class.show]="isDropdownOpen"
    role="menu"
    [attr.aria-hidden]="!isDropdownOpen"
    >
    @for (language of availableLanguages; track language) {
      <button
        class="language-option"
        type="button"
        role="menuitem"
        (click)="selectLanguage(language)"
        [class.active]="language.code === currentLanguage?.code"
        [disabled]="isLoading"
        [attr.aria-label]="'Switch to ' + language.name"
        >
        @if (language.flag) {
          <span class="language-flag">
            {{ language.flag }}
          </span>
        }
        <span class="language-name">
          {{ language.name }}
        </span>
        @if (language.code === currentLanguage?.code) {
          <i
            class="bi bi-check language-check"
            aria-hidden="true"
          ></i>
        }
      </button>
    }
  </div>

  <!-- Feedback Messages -->
  @if (showFeedback) {
    <div class="feedback-container">
      <!-- Success Message -->
      @if (successMessage && !hasError) {
        <div
          class="feedback-message success"
          role="status"
          aria-live="polite"
          >
          <i class="bi bi-check-circle" aria-hidden="true"></i>
          <span>{{ successMessage }}</span>
          <button
            type="button"
            class="feedback-close"
            (click)="dismissFeedback()"
            aria-label="Dismiss success message"
            >
            <i class="bi bi-x" aria-hidden="true"></i>
          </button>
        </div>
      }
      <!-- Error Message -->
      @if (hasError && errorMessage) {
        <div
          class="feedback-message error"
          role="alert"
          aria-live="assertive"
          >
          <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
          <span>{{ errorMessage }}</span>
          <div class="error-actions">
            <button
              type="button"
              class="retry-button"
              (click)="retryLanguageLoad()"
              aria-label="Retry loading language"
              >
              <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
              Retry
            </button>
            <button
              type="button"
              class="recovery-button"
              (click)="attemptRecovery()"
              aria-label="Attempt recovery"
              >
              <i class="bi bi-tools" aria-hidden="true"></i>
              Recover
            </button>
            <button
              type="button"
              class="feedback-close"
              (click)="dismissFeedback()"
              aria-label="Dismiss error message"
              >
              <i class="bi bi-x" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
